"use client"

const ENVIRONMENT_LABEL = (process.env.NEXT_PUBLIC_ENV_LABEL ?? "").trim()

export function EnvironmentBadge() {
  if (!ENVIRONMENT_LABEL) {
    return null
  }

  return (
    <span
      className="rounded-md border border-red-200 bg-red-50 px-2 py-0.5 text-[10px] font-semibold tracking-wide text-red-600"
      title={`Environment: ${ENVIRONMENT_LABEL}`}
    >
      {ENVIRONMENT_LABEL.toUpperCase()}
    </span>
  )
}
